import { css as e, styled as t } from "./styled2.mjs";
import { UploadFileRounded as i } from "@mui/icons-material";
import l from "./Upload.mjs";
import { Typography as n } from "./index59.mjs";
const p = e`
	display: flex;
	flex-direction: column;
	padding: ${({ theme: r }) => r.spacing(2)};
	gap: ${({ theme: r }) => r.spacing(1)};
	justify-content: center;
	align-items: center;
`, c = e`
	display: flex;
	align-items: center;
	gap: ${({ theme: r }) => r.spacing(2)};
	padding-block: ${({ theme: r }) => r.spacing(1)};
	padding-inline: ${({ theme: r }) => r.spacing(2)};
`, $ = t("div")``, u = t(l)`
	${({ $size: r }) => r === "thin" ? c : p};
	border-radius: 8px;
	border: 1px solid;
	border-color: ${({ theme: r, $hasError: o, $isDragOver: a }) => o ? r.palette.error.main : a ? r.palette.primary.main : r.palette.other.divider};

	transition-property: background-color;
	transition-duration: 0.3s;

	background-color: ${({ theme: r }) => r.palette.background.level1};

	color: ${({ theme: r }) => r.palette.primary.main30};

	&:hover {
		cursor: ${({ $isDragOver: r }) => !r && "pointer"};
		border-color: ${({ theme: r, $hasError: o }) => o ? r.palette.error.main : r.palette.primary.main};
	}

	&:focus {
		outline: none;
		box-shadow: ${({ theme: r, $hasError: o }) => o ? `0px 0px 0px 4px ${r.palette.error.main08}` : `0px 0px 0px 4px ${r.palette.primary.main08}`};
	}

	cursor: ${({ $isDragOver: r }) => r && "grabbing"};

	&.rc-upload-disabled {
		color: ${({ theme: r }) => r.palette.action.disabled};
		background-color: ${({ theme: r }) => r.palette.background.level3};
		border-color: ${({ theme: r }) => r.palette.action.disabledBackground};
		cursor: no-drop;
	}
`, m = t(i)`
	font-size: 24px;
	${({ theme: r, $isDisabled: o, $hasError: a }) => a ? e`
				color: ${o ? r.palette.error.main30 : r.palette.error.main};
			` : e`
			color: ${o ? r.palette.primary.main30 : r.palette.primary.main};
		`};
`, f = t("div")`
	display: flex;
	flex-direction: column;
	gap: ${({ theme: r, $size: o }) => o === "thin" ? r.spacing(0.5) : r.spacing(1)};
	justify-content: ${({ $size: r }) => r === "thin" ? "flex-start" : "center"};
	text-align: ${({ $size: r }) => r === "thin" ? "left" : "center"};
`, y = t(n.Body1)`
	color: ${({ theme: r, $isDisabled: o }) => o ? r.palette.text.disabled : r.palette.text.primary};
	text-align: center;
`, b = t(n.Caption)`
	color: ${({ theme: r, $isDisabled: o }) => o ? r.palette.error.main30 : r.palette.error.main};
	padding-left: ${({ theme: r }) => r.spacing(1.75)};
`, v = t("div")`
	margin-top: ${({ theme: r }) => r.spacing(1)};
`, k = t("div")`
	color: ${({ theme: r, $isDisabled: o }) => o ? r.palette.text.disabled : r.palette.text.secondary};
`;
export {
  v as FileListSlot,
  k as HelperTextSlot,
  y as Placeholder,
  b as StyledDropzoneError,
  $ as UploadContainer,
  f as UploadContent,
  m as UploadIcon,
  u as UploadRC
};
//# sourceMappingURL=styles39.mjs.map
